document.addEventListener('DOMContentLoaded', function() {


	// Select the node that will be observed for mutations
	const targetNode = document.querySelector('.recharge-subscription-widget');

	// Options for the observer (which mutations to observe)
	const config = {
		childList: true,
		subtree: true
	};

	// Callback function to execute when mutations are observed
	const callback = (mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList') {
				setupRadioChangeListener();
			}
		}
	};

	// Create an instance of MutationObserver and pass in the callback
	const observer = new MutationObserver(callback);

	// Start observing the target node for configured mutations
	observer.observe(targetNode, config);

	// Optionally, you can stop observing later on
	// observer.disconnect();

	function setupRadioChangeListener() {
		const purchaseOptions = document.querySelectorAll('.rc-radio-group__options');
		setTimeout(() => {

			if (purchaseOptions.length !== 0) {
				const priceLabels = document.querySelectorAll('.price');
				console.log("dddd");
				priceLabels.forEach(function(label) {
					label.style.display = 'none'; // Hide the price element
				});
			}
		}, 1000);

	}




});